import { AuthenticatedLayout } from "../../../../layouts";
import { FC } from "react";
import { RollBackTransactions } from "../../../../components/DirectDeposit/Transactions/RollBackTransactions";


export interface IRollBackTransactionsPage { }

export const RollBackTransactionsPage: FC<IRollBackTransactionsPage> = () => {
	return (
		<AuthenticatedLayout
			pageTitle="Rollback Transactions"
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[]}
			mainContents={<RollBackTransactions />}
		/>
	);
};
